import { render, staticRenderFns } from "./class.vue?vue&type=template&id=2cb691da&scoped=true&"
import script from "./class.vue?vue&type=script&lang=js&"
export * from "./class.vue?vue&type=script&lang=js&"
import style0 from "./class.vue?vue&type=style&index=0&id=2cb691da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb691da",
  null
  
)

export default component.exports